<template>
    <div class="inline-flex border:1|solid|gray04 {p:10|13}>div {p:10|16}>div@<sm {border-left:1|solid|gray04}>div+div r:8 {border-color:$(primaryBittersweet)}.error {border-left-color:$(primaryBittersweet)}.error>div+div" :class="class">
        <div class="flex jc:center">
            <div class="{w:96;t:center}@sm max-w:37@<sm outline:none" :class="minLabel ? '' : 'color:#A9A9A9'">{{ minLabel || "請輸入限６字" }}</div>
        </div>
        <div class="flex ai:center">
            <div class="flex gap:16">
                <span :class="{ 'cursor:pointer': !readonly }" @click="setValue(num)" :key="num" v-for="(num) in max">
                    <img alt="" :src="`${prefix}image/star_${modelValue >= num ? 'on' : 'off'}.svg`" />
                </span>
            </div>
        </div>
        <div class="flex jc:center">
            <div class="{w:96;t:center}@sm max-w:37@<sm outline:none" :class="maxLabel ? '' : 'color:#A9A9A9'">{{ maxLabel || "請輸入限６字" }}</div>
        </div>
    </div>
</template>

<script setup>
    const prefix = inject("prefix");

    const { readonly } = defineProps({
        class: { default: [], type: [String, Array, Object] },
        max: { default: 5, type: Number },
        maxLabel: { type: String },
        minLabel: { type: String },
        modelValue: { default: 0, type: Number },
        readonly: { default: false, type: Boolean }
    });

    const emit = defineEmits(["update:modelValue"]);

    const setValue = (value) => {
        if (!readonly) {
            emit("update:modelValue", value);
        }
    };
</script>
